module.exports = __webpack_public_path__ + "static/media/info.fb2db091.svg";